import { alpha, ThemeOptions } from '@mui/material';

declare module '@mui/material/CircularProgress' {
  // tslint:disable-next-line:interface-name
  interface CircularProgressPropsColorOverrides {
    primaryShadowed: true;
    secondaryShadowed: true;
    errorShadowed: true;
    infoShadowed: true;
    successShadowed: true;
    warningShadowed: true;
  }
}

const muiCircularProgressSvgSize = 44;

export const MuiCircularProgress: ThemeOptions['components']['MuiCircularProgress'] = {
  defaultProps: {
    disableShrink: true
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const circumference = Math.PI * 2 * ((muiCircularProgressSvgSize - ownerState.thickness) / 2);
      const strokeDasharray = circumference.toFixed(3);
      const strokeDashoffset = `${(circumference * 0.5).toFixed(3)}px`;
      const boxShadowColor = alpha(theme.palette.common.black, 0.1);
      const boxShadowThickness =
        typeof ownerState.size === 'number'
          ? `${(ownerState.size / muiCircularProgressSvgSize) * ownerState.thickness}px`
          : ownerState.size;
      return {
        position: 'relative',
        ...(ownerState.variant === 'indeterminate' && {
          animationDuration: '650ms',
          '.MuiCircularProgress-circle': {
            strokeDasharray: strokeDasharray,
            strokeDashoffset: strokeDashoffset
          }
        }),
        ...(ownerState.color.includes('Shadowed') && {
          '&:before': {
            content: '""',
            borderRadius: '100%',
            height: ownerState.size,
            width: ownerState.size,
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            filter: `drop-shadow(1px 2px ${boxShadowThickness} ${boxShadowColor})`,
            boxShadow: `inset 0 0 0 ${boxShadowThickness} ${theme.palette.common.white}`
          }
        })
      };
    },
    svg: {
      position: 'absolute'
    }
  }
};
